import { FC } from "react";

import Rep from "../../models/rep";
import { OnboardingSessions } from "./onboardingSessions";
import { RepSegments } from "./repSegments";
import style from "./style.module.scss";

interface RepDisplayNameProps {
	rep: Rep;
}

export const RepDisplayName: FC<RepDisplayNameProps> = ({ rep }) => {
	const firstName = rep.firstName?.trim();
	const lastName = rep.lastName?.trim();
	const login = rep.login?.trim();

	const loginPart = login ? `(${login})` : "";
	const displayText = [firstName, lastName, loginPart].filter(Boolean).join(" ");

	if (!displayText) {
		return <h1 className={style.headerTitle}>Agent Portal</h1>;
	}

	return (
		<>
			<h1 className={style.headerTitle}>Agent Portal</h1>
			<span className={style.headerDash}>-</span>
			<h2 className={style.headerSubtitle}>{displayText}</h2>
		</>
	);
};

export function OnboardingSelectors() {
	return (
		<div className={style.onboardingSelectors}>
			<OnboardingSessions />
			<RepSegments />
		</div>
	);
}
